// import React from 'react';
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";

import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/css/base.css";
import "./styles/sass/index.scss";
import { CountyContextProvider } from "./store/CountyContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <CountyContextProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </CountyContextProvider>
);
